// Journal index kept in its OWN module so the heavy blog metadata (blogMeta.js)
// is NOT pulled into the main bundle. Only journal/search chunks import this.
// NOTE: BASE_JOURNAL lives here (not in data.js) so the dependency graph is
// strictly one-way — data.js must never import this module (cycle = TDZ crash).
import { BLOG_META } from "./blogMeta";

const BASE_JOURNAL = [
  {
    slug: "best-time-to-visit-north-east-india",
    title: "The Best Time to Visit North East India: A Month-by-Month Guide",
    category: "Planning",
    read: "8 min read",
    date: "Mar 2026",
    excerpt:
      "From the Hornbill Festival in December to the Yumthang blooms of spring — when to travel to each of the seven sisters.",
    image:
      "https://images.pexels.com/photos/1122875/pexels-photo-1122875.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
  },
  {
    slug: "meghalaya-living-root-bridges-guide",
    title: "Walking the Living-Root Bridges of Meghalaya",
    category: "Destinations",
    read: "6 min read",
    date: "Feb 2026",
    excerpt:
      "How the Khasi people grow bridges from living rubber-fig trees — and how to trek the famous double-decker at Nongriat.",
    image:
      "https://images.pexels.com/photos/18158726/pexels-photo-18158726.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
  },
  {
    slug: "bhutan-travel-permits-explained",
    title: "Bhutan Travel in 2026: Permits, SDF & What to Expect",
    category: "Guides",
    read: "7 min read",
    date: "Jan 2026",
    excerpt:
      "Everything you need to know about visiting the last Shangri-La — from the Sustainable Development Fee to the Tiger's Nest trek.",
    image:
      "https://images.pexels.com/photos/1089318/pexels-photo-1089318.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
  },
  {
    slug: "hornbill-festival-complete-guide",
    title: "The Hornbill Festival: A Complete Travel Guide",
    category: "Guides",
    read: "9 min read",
    date: "Apr 2026",
    excerpt:
      "Everything about Nagaland's 'festival of festivals' — dates, what to expect at Kisama, and how to plan your December trip.",
    image:
      "https://images.pexels.com/photos/30952535/pexels-photo-30952535.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
  },
  {
    slug: "north-east-india-permits-ilp-pap",
    title: "Permits for North East India: ILP & PAP Explained",
    category: "Planning",
    read: "7 min read",
    date: "Apr 2026",
    excerpt:
      "Which North East states need an Inner Line Permit, who needs a Protected Area Permit, and how TripTrix arranges them for agents.",
    image:
      "https://images.unsplash.com/photo-1633728476110-9827024ed86b?crop=entropy&cs=srgb&fm=jpg&q=68&w=1200&auto=format",
  },
  {
    slug: "best-treks-in-north-east-india",
    title: "The 7 Best Treks in North East India",
    category: "Adventure",
    read: "8 min read",
    date: "Mar 2026",
    excerpt:
      "From Dzukou Valley to Goecha La — the most rewarding Himalayan and hill treks across the seven sisters and Sikkim.",
    image:
      "https://images.unsplash.com/photo-1742802003145-695a91feb450?crop=entropy&cs=srgb&fm=jpg&q=68&w=1200&auto=format",
  },
  {
    slug: "offbeat-north-east-destinations",
    title: "10 Offbeat North East India Destinations for 2026",
    category: "Destinations",
    read: "7 min read",
    date: "Feb 2026",
    excerpt:
      "Beyond the classics — Majuli, Ziro, Mechuka, Dzukou and more offbeat routes your clients will love.",
    image:
      "https://images.pexels.com/photos/37382698/pexels-photo-37382698.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
  },
];

export const JOURNAL = [...BASE_JOURNAL, ...BLOG_META];
